<div class="container-fluid">
  <div class="table-responsive investor-direct-fee-schedule">
    <table class="table">
      <thead>
        <tr>
          <th class="tabel-header">Current Fee Schedule</th>
        </tr>
      </thead>
      <tbody class="content">
        <tr
          *ngFor="
            let feeData of rcrFeeScheduleData.feeSchedule;
            let index = index;
            let even = even;
            trackBy: trackByIdentity
          "
        >
          <td [ngClass]="{ 'td--light-grey': even }">{{ feeData }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
